function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M279.1,290H89.2c-16.3,0-29.5-13.3-29.5-29.6V125.7c0-16.3,13.3-29.6,29.5-29.6h45.5L147,77.5 c1.4-2.2,3.9-3.5,6.5-3.5h61.4c2.6,0,5.1,1.3,6.5,3.5l12.2,18.6h45.5c16.3,0,29.5,13.3,29.5,29.6v134.8 C308.6,276.7,295.4,290,279.1,290z M89.2,111.7c-7.7,0-14,6.3-14,14v134.8c0,7.7,6.3,14,14,14h189.8c7.7,0,14-6.3,14-14V125.7 c0-7.7-6.3-14-14-14h-49.7c-2.6,0-5.1-1.3-6.5-3.5l-12.2-18.6h-53l-12.2,18.6c-1.4,2.2-3.9,3.5-6.5,3.5H89.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M184.2,252.8c-32.9,0-59.7-26.8-59.7-59.7c0-32.9,26.8-59.7,59.7-59.7c32.9,0,59.7,26.8,59.7,59.7 C243.9,226,217.1,252.8,184.2,252.8z M184.2,148.9c-24.3,0-44.1,19.8-44.1,44.1s19.8,44.1,44.1,44.1s44.1-19.8,44.1-44.1 S208.5,148.9,184.2,148.9z"
})));

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.57a8ebcf.svg";
export { ForwardRef as ReactComponent };